<template>
	<div class="config-option-box">
		<section class="header">题目设置</section>
		<section class="container">
			<field-property @onChangeFormData="handleFormData" :formData="formData" />
		</section>
	</div>
</template>

<script>
import FieldProperty from "./FieldProperty";

export default {
	name: "ConfigOption",
	props: ['formData'],
	components: {
		FieldProperty,
	},
	methods: {
		handleFormData(data) {
			this.$emit('onChangeFormData', data);
			this.formData = Object.assign(this.formData, data);
		}
	},
};
</script>


<style lang="scss" scoped>
.config-option-box {
	width: 100%;
	height: 100%;
	background: #fff;

	& > .header {
		width: 100%;
		height: 40px;
		line-height: 40px;
		font-size: 14px;
		font-weight: 600;
		color: #303133;
		text-align: center;
		border-bottom: solid 1px #DCDFE6;
	}

	& > .container {
		width: 100%;
		height: calc(100% - 40px);
		overflow-x: hidden;
		overflow-y: auto;
		background: #fff;
		&::-webkit-scrollbar {
			display: none;
		}
	}
}
</style>